webpackJsonp([1],{

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var extendDefaults = __webpack_require__(16);
var isBot = !("onscroll" in window) || /glebot/.test(navigator.userAgent);

"use strict";

function Scroll(element, opt) {
    var that = this,
        i = 0;

    this.options = {
        lastScroll: 0,
        ticking: false,
        scrollContainer: window, // window or element,
        scrollDirection: "y", // x or y,
        scroll: {
            width: 0,
            height: 0
        },
        window: {
            width: 0,
            height: 0
        },
        document: {
            width: 0,
            height: 0,
            center: 0
        },
        element: {
            el: "",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            center: 0
        },
        trigger: "center",
        triggerOffset: 0,
        callback: ""
    };

    if ((typeof opt === "undefined" ? "undefined" : _typeof(opt)) === "object") {
        extendDefaults(that.options, opt);
    }

    that.options.window.width = window.innerWidth;
    that.options.window.height = window.innerHeight;
    that.options.scroll.width = that.options.scrollContainer.offsetWidth;
    that.options.scroll.height = that.options.scrollContainer.offsetHeight;
    that.options.element.el = element;
    this.calculatePosition();

    this.options.scrolllistener = that.onScroll.bind(that);
    this.clean = this.cleanUp;

    window.addEventListener("scroll", this.options.scrolllistener, false);
}

Scroll.prototype.calculatePosition = function () {
    if (!this.options.element.el) {
        return;
    }
    var rect = this.options.element.el.getBoundingClientRect();
    var body = document.body,
        html = document.documentElement,
        scrollTop,
        scrollLeft;

    scrollTop = this.options.scrollContainer.scrollTop || window.pageYOffset || document.documentElement.scrollTop;
    scrollLeft = this.options.scrollContainer.scrollLeft || window.pageXOffset || document.documentElement.scrollLeft;

    this.options.document.height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    this.options.document.width = document.documentElement.scrollWidth;

    if (this.options.scrollDirection === "y") {
        if (this.options.trigger === "center") {
            // this.options.element.top = rect.top + scrollTop - (( (rect.bottom + scrollTop) - (rect.top + scrollTop)) / 2);
            this.options.element.top = rect.top + scrollTop + this.options.triggerOffset - rect.height / 2;
            this.options.element.top = rect.top + scrollTop + this.options.triggerOffset;
            this.options.element.bottom = rect.bottom + scrollTop + this.options.triggerOffset - (rect.bottom - rect.top) / 2;
        } else {
            this.options.element.top = rect.top + scrollTop + this.options.triggerOffset;
            this.options.element.bottom = rect.bottom + scrollTop + this.options.triggerOffset;
        }
    } else if (this.options.scrollDirection === "x") {
        if (this.options.trigger === "center") {
            // this.options.element.top = rect.top + scrollTop - (( (rect.bottom + scrollTop) - (rect.top + scrollTop)) / 2);
            this.options.element.left = rect.left + scrollLeft - rect.width / 2;
            this.options.element.left = rect.left + scrollLeft;
            this.options.element.right = rect.right + scrollLeft - (rect.right - rect.left) / 2;
        } else {
            this.options.element.left = rect.left + scrollLeft;
            this.options.element.right = rect.right + scrollLeft;
        }
    }

    if (isBot) {
        this.options.callback.call(this.options.element.el);
    }
};

Scroll.prototype.cleanUp = function () {
    window.removeEventListener("scroll", this.options.scrolllistener, false);
};

Scroll.prototype.onScroll = function () {
    if (this.options.scrollDirection === "y") {
        this.options.lastScroll = this.options.scrollContainer.scrollY || this.options.scrollContainer.scrollTop;
    } else {
        this.options.lastScroll = this.options.scrollContainer.scrollX || this.options.scrollContainer.scrollLeft;
    }

    this.options.document.center = this.options.lastScroll + this.options.window.height / 2;
    this.requestTick();
};

Scroll.prototype.update = function () {
    this.options.ticking = false;

    if (this.options.scrollContainer === window) {
        if (this.options.scrollDirection === "y") {
            if (this.options.trigger == "center") {
                if (parseInt(this.options.lastScroll + this.options.window.height / 2) >= this.options.element.top) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            } else if (this.options.trigger == "top") {
                if (this.options.lastScroll >= this.options.element.top) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            } else {
                if (this.options.lastScroll + this.options.window.height > this.options.element.bottom) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            }
        } else {
            if (this.options.trigger == "center") {
                if (parseInt(this.options.lastScroll + this.options.window.width / 2) >= this.options.element.left) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            } else if (this.options.trigger == "top") {
                if (this.options.lastScroll >= this.options.element.left) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            } else {
                if (this.options.lastScroll + this.options.window.width > this.options.element.right) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            }
        }
    } else {
        if (this.options.scrollDirection === "y") {
            if (this.options.trigger == "center") {
                if (parseInt(this.options.lastScroll + this.options.scroll.height / 2) >= this.options.element.top) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            } else if (this.options.trigger == "top") {
                if (this.options.lastScroll >= this.options.element.top) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            } else {
                if (this.options.lastScroll + this.options.scroll.height > this.options.element.bottom) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            }
        } else {
            if (this.options.trigger == "center") {
                if (parseInt(this.options.lastScroll + this.options.scroll.width / 2) >= this.options.element.left) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            } else if (this.options.trigger == "top") {
                if (this.options.lastScroll >= this.options.element.left) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            } else {
                if (this.options.lastScroll + this.options.scroll.width > this.options.element.right) {
                    this.options.callback.call(this.options.element.el);

                    if (this.options.once) {
                        window.removeEventListener("scroll", this.options.scrolllistener, false);
                    }
                }
            }
        }
    }
};

Scroll.prototype.requestTick = function () {
    if (!this.options.ticking) {
        window.requestAnimationFrame(this.update.bind(this));
    }
    this.options.ticking = true;
};

exports.default = Scroll;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// components/filter/index

function Filter() {
    this.filter = document.querySelector(".filter");
    if (this.filter) {
        this.label = this.filter.querySelector(".filter__label");
    } else {
        return false;
    }

    if (this.filter.nodeType !== 1) {
        return false;
    }

    this.eventListeners();
}

Filter.prototype.eventListeners = function () {
    this.events = {
        body: this.bodyClick.bind(this)
    };

    this.label.addEventListener("click", this.onClick.bind(this), false);

    this.filter.addEventListener("click", function (e) {
        e.stopPropagation();
    });
};

Filter.prototype.bodyClick = function () {
    this.filter.classList.remove("is-open");
};

Filter.prototype.onClick = function () {
    this.filter.classList.toggle("is-open");
    document.addEventListener("click", this.events.body);
};

exports.default = Filter;

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

;(function(window){
var hadGlobal = 'Modernizr' in window;
var oldGlobal = window.Modernizr;
/*! modernizr 3.11.4 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssanimations-requestanimationframe-setclasses !*/
!function(e,n,t,r){function o(e,n){return typeof e===n}function i(e,n){return!!~(""+e).indexOf(n)}function s(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):_?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(){var e=t.body;return e||(e=s(_?"svg":"body"),e.fake=!0),e}function l(e,n,r,o){var i,l,f,u,p="modernizr",c=s("div"),d=a();if(parseInt(r,10))for(;r--;)f=s("div"),f.id=o?o[r]:p+(r+1),c.appendChild(f);return i=s("style"),i.type="text/css",i.id="s"+p,(d.fake?d:c).appendChild(i),d.appendChild(c),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),c.id=p,d.fake&&(d.style.background="",d.style.overflow="hidden",u=S.style.overflow,S.style.overflow="hidden",S.appendChild(d)),l=n(c,e),d.fake?(d.parentNode.removeChild(d),S.style.overflow=u,S.offsetHeight):c.parentNode.removeChild(c),!!l}function f(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function u(e,t,r){var o;if("getComputedStyle"in n){o=getComputedStyle.call(n,e,t);var i=n.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var s=i.error?"error":"log";i[s].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!t&&e.currentStyle&&e.currentStyle[r];return o}function p(e,t){var o=e.length;if("CSS"in n&&"supports"in n.CSS){for(;o--;)if(n.CSS.supports(f(e[o]),t))return!0;return!1}if("CSSSupportsRule"in n){for(var i=[];o--;)i.push("("+f(e[o])+":"+t+")");return i=i.join(" or "),l("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"===u(e,null,"position")})}return r}function c(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function d(e,n,t,a){function l(){u&&(delete P.style,delete P.modElem)}if(a=!o(a,"undefined")&&a,!o(t,"undefined")){var f=p(e,t);if(!o(f,"undefined"))return f}for(var u,d,m,v,y,h=["modernizr","tspan","samp"];!P.style&&h.length;)u=!0,P.modElem=s(h.shift()),P.style=P.modElem.style;for(m=e.length,d=0;d<m;d++)if(v=e[d],y=P.style[v],i(v,"-")&&(v=c(v)),P.style[v]!==r){if(a||o(t,"undefined"))return l(),"pfx"!==n||v;try{P.style[v]=t}catch(e){}if(P.style[v]!==y)return l(),"pfx"!==n||v}return l(),!1}function m(e,n){return function(){return e.apply(n,arguments)}}function v(e,n,t){var r;for(var i in e)if(e[i]in n)return!1===t?e[i]:(r=n[e[i]],o(r,"function")?m(r,t||n):r);return!1}function y(e,n,t,r,i){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+b.join(s+" ")+s).split(" ");return o(n,"string")||o(n,"undefined")?d(a,n,r,i):(a=(e+" "+z.join(s+" ")+s).split(" "),v(a,n,t))}function h(e,n,t){return y(e,r,r,n,t)}var g=[],C={_version:"3.11.4",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){g.push({name:e,fn:n,options:t})},addAsyncTest:function(e){g.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var w=[],S=t.documentElement,_="svg"===S.nodeName.toLowerCase(),x="Moz O ms Webkit",b=C._config.usePrefixes?x.split(" "):[];C._cssomPrefixes=b;var E={elem:s("modernizr")};Modernizr._q.push(function(){delete E.elem});var P={style:E.elem.style};Modernizr._q.unshift(function(){delete P.style});var z=C._config.usePrefixes?x.toLowerCase().split(" "):[];C._domPrefixes=z,C.testAllProps=y;var N=function(e){var t,o=prefixes.length,i=n.CSSRule;if(void 0===i)return r;if(!e)return!1;if(e=e.replace(/^@/,""),(t=e.replace(/-/g,"_").toUpperCase()+"_RULE")in i)return"@"+e;for(var s=0;s<o;s++){var a=prefixes[s];if(a.toUpperCase()+"_"+t in i)return"@-"+a.toLowerCase()+"-"+e}return!1};C.atRule=N;var T=C.prefixed=function(e,n,t){return 0===e.indexOf("@")?N(e):(-1!==e.indexOf("-")&&(e=c(e)),n?y(e,n,t):y(e,"pfx"))};Modernizr.addTest("requestanimationframe",!!T("requestAnimationFrame",n),{aliases:["raf"]}),C.testAllProps=h,Modernizr.addTest("cssanimations",h("animationName","a",!0)),function(){var e,n,t,r,i,s,a;for(var l in g)if(g.hasOwnProperty(l)){if(e=[],n=g[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(r=o(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=r:(Modernizr[a[0]]&&(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean)||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=r),w.push((r?"":"no-")+a.join("-"))}}(),function(e){var n=S.className,t=Modernizr._config.classPrefix||"";if(_&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(e.length>0&&(n+=" "+t+e.join(" "+t)),_?S.className.baseVal=n:S.className=n)}(w),delete C.addTest,delete C.addAsyncTest;for(var j=0;j<Modernizr._q.length;j++)Modernizr._q[j]();e.Modernizr=Modernizr}(window,window,document);
module.exports = window.Modernizr;
if (hadGlobal) { window.Modernizr = oldGlobal; }
else { delete window.Modernizr; }
})(window);

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(45);
module.exports = __webpack_require__(46);


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// components/inputs/index

function Inputs() {
    var inputs = document.querySelectorAll(".ginput_container");

    for (var i = 0; i < inputs.length; i++) {
        var focus = document.createElement("div");
        focus.classList.add("input-focus");
        inputs[i].appendChild(focus);
    }
}

exports.default = Inputs;

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Router = __webpack_require__(64);

var _Router2 = _interopRequireDefault(_Router);

var _pageController = __webpack_require__(67);

var _pageController2 = _interopRequireDefault(_pageController);

var _common = __webpack_require__(54);

var _common2 = _interopRequireDefault(_common);

var _home = __webpack_require__(55);

var _home2 = _interopRequireDefault(_home);

var _postTypeArchiveProducts = __webpack_require__(57);

var _postTypeArchiveProducts2 = _interopRequireDefault(_postTypeArchiveProducts);

var _postTypeArchiveRecipes = __webpack_require__(58);

var _postTypeArchiveRecipes2 = _interopRequireDefault(_postTypeArchiveRecipes);

var _taxRecipe_category = __webpack_require__(63);

var _taxRecipe_category2 = _interopRequireDefault(_taxRecipe_category);

var _postTypeArchiveStockist = __webpack_require__(59);

var _postTypeArchiveStockist2 = _interopRequireDefault(_postTypeArchiveStockist);

var _singleProducts = __webpack_require__(61);

var _singleProducts2 = _interopRequireDefault(_singleProducts);

var _singleRecipes = __webpack_require__(62);

var _singleRecipes2 = _interopRequireDefault(_singleRecipes);

var _pageTemplateBlog = __webpack_require__(56);

var _pageTemplateBlog2 = _interopRequireDefault(_pageTemplateBlog);

var _singleJobs = __webpack_require__(60);

var _singleJobs2 = _interopRequireDefault(_singleJobs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import "jquery";
var routes = new _Router2.default({
    common: _common2.default,
    home: _home2.default,
    postTypeArchiveProducts: _postTypeArchiveProducts2.default,
    taxProductCategories: _postTypeArchiveProducts2.default,
    postTypeArchiveRecipes: _postTypeArchiveRecipes2.default,
    taxRecipeCategory: _taxRecipe_category2.default,
    postTypeArchiveStockist: _postTypeArchiveStockist2.default,
    singleProducts: _singleProducts2.default,
    singleRecipes: _singleRecipes2.default,
    // pageTemplateContact,
    // pageTemplateMission,
    pageTemplateBlog: _pageTemplateBlog2.default,
    category: _pageTemplateBlog2.default,
    singleJobs: _singleJobs2.default
});
// import pageTemplateContact from "./routes/page-template-contact";
// import pageTemplateMission from "./routes/page-template-mission";


function ready(func) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
        func();
    } else {
        document.addEventListener("DOMContentLoaded", func);
    }
}

function loadEvents() {
    if (document.body.classList.contains("ie") || document.body.classList.contains("edge")) {
        routes.loadEvents();
    } else {
        var pagecontroller = new _pageController2.default({
            events: {
                afterLoad: function afterLoad() {
                    routes.loadEvents();
                }
            }
        });
    }

    // routes.loadEvents();
}

ready(loadEvents);

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flickityFade = __webpack_require__(73);

var _flickityFade2 = _interopRequireDefault(_flickityFade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(44);
__webpack_require__(158);

function Carousels(selector) {
    var carousels = selector;

    if (typeof selector === "string") {
        carousels = document.querySelectorAll(selector);
    }

    if (!carousels) return;

    // console.log({ carousels });

    Array.from(carousels, function (carousel) {
        new Carousel(carousel);
    });

    // carousels.map((carousel, index) => {
    //     new Carousel(carousel);
    // });
}

function Carousel(carousel) {
    var contents = carousel.querySelector(".carousel__contents .carousel__slides");
    var images = carousel.querySelector(".carousel__images .carousel__slides");
    var number = carousel.querySelector(".carousel__number");
    if (!contents || !images) {
        return;
    }

    var contents_flickity = new _flickityFade2.default(contents, {
        selectedAttraction: 1,
        friction: 1,
        cellAlign: "left",
        wrapAround: true,
        pageDots: true,
        prevNextButtons: true,
        groupCells: false,
        imagesLoaded: true,
        autoPlay: false,
        on: {
            ready: function ready() {
                console.log("contents");
                console.log(this);
                if (number) {
                    number.innerHTML = this.selectedIndex + 1 + "/" + this.cells.length;
                }
            }
        }
        // arrowShape:
        // "M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z",
    });

    contents_flickity.on("change", function (index) {
        images_flickity.select(index);
        if (number) {
            number.innerHTML = index + 1 + "/" + contents_flickity.cells.length;
        }
    });

    var images_flickity = new _flickityFade2.default(images, {
        selectedAttraction: 0.1,
        friction: 1,
        cellAlign: "left",
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        groupCells: false,
        imagesLoaded: true,
        autoPlay: false,
        fade: true,
        draggable: false
    });
}

exports.default = Carousels;

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nav = __webpack_require__(50);

var _nav2 = _interopRequireDefault(_nav);

var _search = __webpack_require__(53);

var _search2 = _interopRequireDefault(_search);

var _lodash = __webpack_require__(27);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Header() {
    var that = this;
    var doc = document.documentElement;
    var lastScroll = 0;
    this.header = document.querySelector(".header");
    this.navigation = new _nav2.default();
    this.search = new _search2.default();

    var scroll = (0, _lodash2.default)(function () {
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (top > 0) {
            that.header.classList.remove("top");
            if (top < lastScroll && top > 0) {
                that.header.classList.add("float");
                top++; // Fix for ie - trick that fixes showing/hiding on every scroll
            } else {
                that.header.classList.remove("float");
            }
        } else {
            that.header.classList.add("top");
            that.header.classList.remove("float");
        }
        lastScroll = top;
    }, 100);

    scroll();
    window.addEventListener("scroll", scroll);
} /* jslint es6 */
exports.default = Header;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _transitionEnd = __webpack_require__(17);

var _transitionEnd2 = _interopRequireDefault(_transitionEnd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Navigation() {
    this.nav = document.querySelector(".nav");
    this.menuButton = document.querySelector(".menu-button");
    // this.submenus = document.querySelectorAll(".sub-menu");

    // if (this.submenus.length > 0) {
    //     for (var i = 0; i < this.submenus.length; i++) {
    //         this.submenus[i].insertAdjacentHTML("beforebegin", "<div class='nav__subnav-revealer'><i class='fa fa-chevron-left'></i></div>");
    //         var revealer = this.submenus[i].previousElementSibling;

    //         revealer.addEventListener("click", function () {
    //             this.classList.toggle("is-open");
    //             jQuery(this).next("ul").slideToggle(500);
    //         });
    //     }
    // }

    this.eventListeners();
} // components/nav/index

Navigation.prototype.eventListeners = function () {
    this.events = {
        body: this.bodyClick.bind(this),
        transitionend: this.transitionEnd.bind(this)
    };
    this.menuButton.addEventListener("click", this.onClick.bind(this), false);
    this.nav.addEventListener("click", function (e) {
        e.stopPropagation();
    });
};

Navigation.prototype.onClick = function (e) {
    e.stopPropagation();
    this.menuButton.classList.toggle("is-open");
    this.nav.classList.toggle("is-open");
    document.body.classList.toggle("is-menu-open");

    this.nav.addEventListener(_transitionEnd2.default, this.events.transitionend);
};

Navigation.prototype.bodyClick = function () {
    this.menuButton.classList.remove("is-open");
    this.nav.classList.remove("is-open");
    document.body.classList.remove("is-menu-open");

    document.removeEventListener("click", this.events.body);
};

Navigation.prototype.transitionEnd = function () {
    document.addEventListener("click", this.events.body);
    this.nav.removeEventListener(_transitionEnd2.default, this.events.transitionend);
};

exports.default = Navigation;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flickity = __webpack_require__(8);

var _flickity2 = _interopRequireDefault(_flickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(44);

function ProductCarousels(selector) {
    var carousels = selector;

    if (typeof selector === "string") {
        carousels = document.querySelectorAll(selector);
    }

    if (!carousels) return;

    Array.from(carousels, function (carousel) {
        new Carousel(carousel);
    });
}

function Carousel(carousel) {
    var contents_flickity = new _flickity2.default(".carousel--products", {
        selectedAttraction: 0.1,
        friction: 1,
        cellAlign: "left",
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        groupCells: true,
        imagesLoaded: true,
        autoPlay: false
        // arrowShape:
        // "M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z",
    });
}

exports.default = ProductCarousels;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputs = __webpack_require__(24);

var _inputs2 = _interopRequireDefault(_inputs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Rating() {
    var object = {
        el: document.querySelector(".rating"),
        rating: "",
        ratingField: "",
        form: "",
        close: ""
    },
        i = 0;

    if (object.el === null || object.el.nodeType !== 1) {
        return false;
    }

    var inputs = new _inputs2.default();

    object.rating = object.el.getAttribute("data-rating");
    object.stars = object.el.querySelectorAll(".rating__star");
    object.form = object.el.querySelector(".rating__form");
    object.ratingField = object.form.querySelector("#input_1_5");
    object.close = object.form.querySelector(".rating__close");

    for (i = 0; i < object.rating; i++) {
        object.stars[i].classList.add("is-rated");
    }

    for (i = 0; i < object.stars.length; i++) {
        object.stars[i].addEventListener("click", this.clickHandler.bind(object.stars[i], object));
    }

    object.close.addEventListener("click", function () {
        object.form.classList.remove("is-visible");
    });
} // components/rating/index

Rating.prototype.clickHandler = function (object) {
    var value = this.getAttribute("data-value"),
        i = 0;

    object.setRating = value;
    object.ratingField.value = object.setRating;

    object.form.classList.add("is-visible");

    for (i = 0; i < object.stars.length; i++) {
        object.stars[i].classList.remove("is-rated");
    }

    for (i = 0; i < value; i++) {
        object.stars[i].classList.add("is-rated");
    }
};

exports.default = Rating;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _transitionEnd = __webpack_require__(17);

var _transitionEnd2 = _interopRequireDefault(_transitionEnd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Search() {
    this.button = document.querySelector(".search-button");
    this.searchHeader = document.querySelector(".search-header");
    this.input = this.searchHeader.querySelector("input");
    this.close = this.searchHeader.querySelector(".search-header__close");

    this.events = {
        body: this.bodyClick.bind(this),
        transitionend: this.transitionEnd.bind(this)
    };

    this.button.addEventListener("click", this.onClick.bind(this));

    this.searchHeader.addEventListener("click", function (e) {
        e.stopPropagation();
    });
} // components/search/index

Search.prototype.onClick = function () {
    this.searchHeader.classList.toggle("is-visible");
    document.body.classList.toggle("is-search-open");
    document.documentElement.classList.toggle("is-search-open");

    this.searchHeader.addEventListener(_transitionEnd2.default, this.events.transitionend);
};

Search.prototype.transitionEnd = function () {
    document.addEventListener("click", this.events.body);
    this.close.addEventListener("click", this.events.body);
    this.searchHeader.removeEventListener(_transitionEnd2.default, this.events.transitionend);
    this.input.focus();
};

Search.prototype.bodyClick = function () {
    this.searchHeader.classList.remove("is-visible");
    document.body.classList.remove("is-search-open");
    document.documentElement.classList.remove("is-search-open");

    document.removeEventListener("click", this.events.body);
};

exports.default = Search;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _header = __webpack_require__(49);

var _header2 = _interopRequireDefault(_header);

var _clippath = __webpack_require__(66);

var _clippath2 = _interopRequireDefault(_clippath);

var _scroller = __webpack_require__(1);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollto = __webpack_require__(69);

var _scrollto2 = _interopRequireDefault(_scrollto);

var _objectFitImages = __webpack_require__(150);

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(51);

var _index4 = _interopRequireDefault(_index3);

var _scrollViewport = __webpack_require__(68);

var _scrollViewport2 = _interopRequireDefault(_scrollViewport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(159);

var LazyLoad = __webpack_require__(157);

exports.default = {
    init: function init() {
        var header = new _header2.default(),
            detectie = __webpack_require__(71),
            lazyload = new LazyLoad({ data_srcset: "srcSet" }),
            footer = "",
            newsletter_signup = "",
            scrollto = {
            elements: document.querySelectorAll(".scroll"),
            scroll: []
        };

        new _index2.default(".carousel");

        new _index4.default(".carousel--products");

        if (detectie() !== false) {
            document.documentElement.classList.add("ie");
        } else {
            document.documentElement.classList.add("no-ie");
        }

        if ((0, _clippath2.default)()) {
            document.documentElement.classList.add("clip-path");
        } else {
            document.documentElement.classList.add("no-clip-path");
        }

        setTimeout(function () {
            new _scrollViewport2.default({
                className: ".scroll-trigger"
            });
        }, 500);

        function callback() {
            this.classList.add("is-visible");
        }

        // if (document.querySelector(".newsletter-signup")) {
        //     newsletter_signup = new Scroller(
        //         document.querySelector(".newsletter-signup"),
        //         {
        //             callback: callback,
        //             triggerOffset: -250,
        //             once: true,
        //         }
        //     );

        //     var form = document.querySelector(".newsletter-signup form");
        //     var alert = form.querySelector(".newsletter-signup__alert");

        //     form.addEventListener("submit", function (e) {
        //         e.preventDefault();

        //         var data = new FormData(form);
        //         var json = {};

        //         for (var entry of data.entries()) {
        //             json[entry[0]] = entry[1];
        //         }
        //         json = JSON.stringify(json);

        //         jQuery.ajax({
        //             type: "POST",
        //             url: form.getAttribute("action"),
        //             data: jQuery(form).serialize(),
        //             dataType: "jsonp",
        //             error: function (err) {
        //                 jQuery(alert)
        //                     .removeClass("success")
        //                     .addClass("bg-red error");
        //                 jQuery(alert).html("");
        //                 jQuery(alert).append(
        //                     "<i class='fa fa-thumbs-down'></i>"
        //                 );
        //                 jQuery(alert).append(
        //                     "<p>There was an error. Please try again.</p>"
        //                 );
        //             },
        //             success: function (data) {
        //                 if (data.result !== "error") {
        //                     jQuery(alert)
        //                         .removeClass("error")
        //                         .addClass("bg-green-2 success");
        //                     jQuery(alert).html("");
        //                     jQuery(alert).append(
        //                         "<i class='fa fa-thumbs-up'></i>"
        //                     );
        //                     jQuery(alert).append("<p>" + data.msg + "</p>");
        //                 } else {
        //                     jQuery(alert)
        //                         .removeClass("success")
        //                         .addClass("bg-red error");
        //                     jQuery(alert).html("");
        //                     jQuery(alert).append(
        //                         "<i class='fa fa-thumbs-down'></i>"
        //                     );
        //                     jQuery(alert).append("<p>" + data.msg + "</p>");
        //                 }
        //             },
        //         });
        //     });
        // }

        if (document.querySelector(".footer")) {
            footer = new _scroller2.default(document.querySelector(".footer"), {
                trigger: "bottom",
                callback: callback,
                triggerOffset: -150,
                once: true
            });
        }

        // if (document.querySelector(".floater")) {
        //     var head = document.head,
        //         link = document.createElement("link");

        //     link.type = "text/css";
        //     link.rel = "stylesheet";
        //     link.href = "/app/themes/rawhealth/dist/css/floats.css";

        //     head.appendChild(link);
        // }

        if (scrollto.elements.length > 0) {
            for (var i = 0; i < scrollto.elements.length; i++) {
                var target = document.querySelector(scrollto.elements[i].getAttribute("data-target"));
                var offset = scrollto.elements[i].getAttribute("data-offset");

                // if (!offset) {
                //     offset = 0;
                // }

                scrollto.elements[i].addEventListener("click", function () {
                    (0, _scrollto2.default)(this.getAttribute("data-target"), -150);
                });
            }
        }
    },
    finalize: function finalize() {
        (0, _objectFitImages2.default)();

        document.addEventListener("contentLoaded", function () {
            (0, _objectFitImages2.default)();
        });
    }
};

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _scroller = __webpack_require__(1);

var _scroller2 = _interopRequireDefault(_scroller);

var _moveit = __webpack_require__(7);

var _moveit2 = _interopRequireDefault(_moveit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {},
    finalize: function finalize() {
        var banner,
            productCarousel,
            recipes = {
            list_item: document.querySelectorAll(".list-item--recipe"),
            scroller: [],
            callback: function callback() {
                this.classList.add("is-visible");
            }
        },
            mission = {
            list_item: document.querySelectorAll(".mission-home-item picture"),
            scroller: [],
            callback: function callback() {
                this.classList.add("is-visible");
            }
        },
            moveit = new _moveit2.default(),
            i = 0;

        for (i = 0; i < recipes.list_item.length; i++) {
            recipes.scroller[i] = new _scroller2.default(recipes.list_item[i], {
                callback: recipes.callback,
                once: true,
                triggerOffset: -300
            });
        }

        for (i = 0; i < mission.list_item.length; i++) {
            mission.scroller[i] = new _scroller2.default(mission.list_item[i], {
                callback: mission.callback,
                once: true,
                triggerOffset: -300
            });
        }
    }
};

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _filter = __webpack_require__(15);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Instagram from "../components/instagram";

exports.default = {
    init: function init() {
        this.Filters = new _filter2.default();
        // new Instagram();
    },
    finalize: function finalize() {}
}; // routes/page-template-blog

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _scroller = __webpack_require__(1);

var _scroller2 = _interopRequireDefault(_scroller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        var recipes = {
            list_item: document.querySelectorAll(".list-item--recipe"),
            scroller: [],
            callback: function callback() {
                this.classList.add("is-visible");
            }
        };

        for (var i = 0; i < recipes.list_item.length; i++) {
            recipes.scroller[i] = new _scroller2.default(recipes.list_item[i], {
                callback: recipes.callback,
                once: true,
                triggerOffset: -125
            });
        }
    },
    finalize: function finalize() {}
}; //

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _scroller = __webpack_require__(1);

var _scroller2 = _interopRequireDefault(_scroller);

var _moveit = __webpack_require__(7);

var _moveit2 = _interopRequireDefault(_moveit);

var _filter = __webpack_require__(15);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        this.Filters = new _filter2.default();
        var recipes = {
            list_item: document.querySelectorAll(".list-item--recipe"),
            scroller: [],
            callback: function callback() {
                this.classList.add("is-visible");
            }
        },
            i = 0,
            moveit = new _moveit2.default();

        for (i = 0; i < recipes.list_item.length; i++) {
            recipes.scroller[i] = new _scroller2.default(recipes.list_item[i], {
                callback: recipes.callback,
                once: true,
                triggerOffset: -125
            });
        }
    },
    finalize: function finalize() {}
};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promisePolyfill = __webpack_require__(152);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flickity = __webpack_require__(8); // routes/post-type-archive-stockist

exports.default = {
    init: function init() {
        if (!window.promise) {
            window.Promise = _promisePolyfill2.default;
        }

        __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 161)).then(function (Map) {
            var map;

            if (window.isMapInit === true) {
                map = new Map.default();
            } else {
                document.addEventListener("map-init", function () {
                    console.log("event");
                    map = new Map.default();
                });
            }
        });
        if (document.querySelector(".online-stockists_slide")) {
            var online_stockists = new Flickity(".online-stockists_slide", {
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 60,
                    y2: 50,
                    x3: 60
                }
            });
        }
        if (document.querySelector(".supermarkets-retailers_slide")) {
            var spmkt_stockists = new Flickity(".supermarkets-retailers_slide", {
                autoPlay: true,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 60,
                    y2: 50,
                    x3: 60
                }
            });
        }
    },
    finalize: function finalize() {}
};

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _inputs = __webpack_require__(24);

var _inputs2 = _interopRequireDefault(_inputs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        var inputs = new _inputs2.default();
    },
    finalize: function finalize() {}
}; // routes/single-jobs

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _scroller = __webpack_require__(1);

var _scroller2 = _interopRequireDefault(_scroller);

var _moveit = __webpack_require__(7);

var _moveit2 = _interopRequireDefault(_moveit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        var recipes = {
            list_item: document.querySelectorAll(".list-item--recipe"),
            scroller: [],
            callback: function callback() {
                this.classList.add("is-visible");
            }
        },
            i = 0,
            moveit = new _moveit2.default();

        for (i = 0; i < recipes.list_item.length; i++) {
            recipes.scroller[i] = new _scroller2.default(recipes.list_item[i], {
                callback: recipes.callback,
                once: true,
                triggerOffset: -250
            });
        }
    },
    finalize: function finalize() {}
};

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _scroller = __webpack_require__(1);

var _scroller2 = _interopRequireDefault(_scroller);

var _rating = __webpack_require__(52);

var _rating2 = _interopRequireDefault(_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        function callback() {
            this.classList.add("is-visible");
        }

        var related_products = new _scroller2.default(document.querySelector(".product-list"), {
            callback: callback,
            triggerOffset: -250
        });

        var rating = new _rating2.default();
    },
    finalize: function finalize() {}
};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _scroller = __webpack_require__(1);

var _scroller2 = _interopRequireDefault(_scroller);

var _moveit = __webpack_require__(7);

var _moveit2 = _interopRequireDefault(_moveit);

var _filter = __webpack_require__(15);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flickity = __webpack_require__(8);

exports.default = {
    init: function init() {
        this.Filters = new _filter2.default();
        var recipes = {
            list_item: document.querySelectorAll(".list-item--recipe"),
            scroller: [],
            callback: function callback() {
                this.classList.add("is-visible");
            }
        },
            i = 0,
            moveit = new _moveit2.default();

        for (i = 0; i < recipes.list_item.length; i++) {
            recipes.scroller[i] = new _scroller2.default(recipes.list_item[i], {
                callback: recipes.callback,
                once: true
            });
        };

        var banner = new Flickity(".banner ul", {
            cellAlign: "left",
            arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 60,
                y2: 50,
                x3: 60
            },
            pageDots: false
        });
    },
    finalize: function finalize() {}
};

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* ========================================================================
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DOM-based Routing
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Based on http://goo.gl/EUTi53 by Paul Irish
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Only fires on body classes that match. If a body class contains a dash,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * replace the dash with an underscore when adding it to the object below.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ======================================================================== */

var _camelCase = __webpack_require__(65);

var _camelCase2 = _interopRequireDefault(_camelCase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var Router = function () {
    function Router(routes) {
        _classCallCheck(this, Router);

        this.routes = routes;
    }

    _createClass(Router, [{
        key: "fire",
        value: function fire(route) {
            var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "init";
            var args = arguments[2];

            var fire = route !== "" && this.routes[route] && typeof this.routes[route][fn] === "function";
            if (fire) {
                this.routes[route][fn](args);
            }
        }
    }, {
        key: "loadEvents",
        value: function loadEvents() {
            var _this = this;

            // Fire common init JS
            this.fire("common");

            // Fire page-specific init JS, and then finalize JS
            document.body.className.toLowerCase().replace(/-/g, "_").split(/\s+/).map(_camelCase2.default).forEach(function (className) {
                _this.fire(className);
                _this.fire(className, "finalize");
            });

            // Fire common finalize JS
            this.fire("common", "finalize");
        }
    }]);

    return Router;
}();

exports.default = Router;

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// the most terrible camelizer on the internet, guaranteed!
exports.default = function (str) {
  return '' + str.charAt(0).toLowerCase() + str.replace(/[\W_]/g, '|').split('|').map(function (part) {
    return '' + part.charAt(0).toUpperCase() + part.slice(1);
  }).join('').slice(1);
};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function checkClipPath() {
    var base = "clipPath",
        prefixes = ["webkit", "moz", "ms", "o"],
        properties = [base],
        testElement = document.createElement("testelement"),
        attribute = "polygon(50% 0%, 0% 100%, 100% 100%)",
        i = 0,
        l = "";

    // Push the prefixed properties into the array of properties.
    for (i = 0, l = prefixes.length; i < l; i++) {
        var prefixedProperty = prefixes[i] + base.charAt(0).toUpperCase() + base.slice(1); // remember to capitalize!
        properties.push(prefixedProperty);
    }

    // Interate over the properties and see if they pass two tests.
    for (i = 0, l = properties.length; i < l; i++) {
        var property = properties[i];

        // First, they need to even support clip-path (IE <= 11 does not)...
        if (testElement.style[property] === "") {

            // Second, we need to see what happens when we try to create a CSS shape...
            testElement.style[property] = attribute;
            if (testElement.style[property] !== "") {
                return true;
            }
        }
    }

    return false;
}

exports.default = checkClipPath;

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // util/page-controller

var _extendDefaults = __webpack_require__(16);

var _extendDefaults2 = _interopRequireDefault(_extendDefaults);

var _transitionEnd = __webpack_require__(17);

var _transitionEnd2 = _interopRequireDefault(_transitionEnd);

var _ajax = __webpack_require__(47);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

"use strict";

(function () {
    if (typeof window.CustomEvent === "function") return false; //If not IE

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

function PageController(opt) {
    var that = this;

    that.options = {
        classes: {
            link: ".ajax",
            wrapper: ".wrapper",
            in: "transition-in",
            out: "transition-out"
        },
        events: {
            init: "",
            afterLoad: "",
            click: ""
        },
        elements: {
            links: [],
            wrapper: ""
        },
        click: new CustomEvent("page-click")
    };

    if ((typeof opt === "undefined" ? "undefined" : _typeof(opt)) === "object") {
        (0, _extendDefaults2.default)(that.options, opt);
    }

    this.eventListeners();

    if (typeof that.options.events.init === "function") {
        that.options.events.init.call();
    }

    window.addEventListener("popstate", function () {
        window.location.href = window.location.href;
    });

    if (typeof that.options.events.afterLoad === "function") {
        that.options.events.afterLoad.call(that);
    }
}

PageController.prototype.eventListeners = function () {
    var i = 0;
    this.options.elements.wrapper = document.querySelector(this.options.classes.wrapper);
    this.options.elements.links = document.querySelectorAll(this.options.classes.link);

    for (i = 0; i < this.options.elements.links.length; i++) {
        this.options.elements.links[i].addEventListener("click", this.click.bind({ link: this.options.elements.links[i], controller: this }), false);
    }
};

PageController.prototype.transitionEnd = function () {
    this.controller.options.elements.wrapper.removeEventListener(_transitionEnd2.default, this.controller.options.transitionEnd, false);
    document.body.classList.remove(this.controller.options.classes.out);

    var bodyClass = this.content.querySelector("body"),
        title = this.content.querySelector("title");

    document.body.classList.value = bodyClass.classList.value;
    scroll(0, 0);

    document.title = title.innerHTML;

    this.controller.options.elements.wrapper.innerHTML = "";
    this.controller.options.elements.wrapper.innerHTML = this.content.querySelector(this.controller.options.classes.wrapper).innerHTML;

    if (typeof this.controller.options.events.afterLoad === "function") {
        this.controller.eventListeners();
        this.controller.options.events.afterLoad.call(this);
    }
};

PageController.prototype.update = function (obj) {
    var bodyClass = obj.content.querySelector("body"),
        title = obj.content.querySelector("title"),
        scripts = obj.content.querySelector(obj.controller.options.classes.wrapper).querySelectorAll("script");

    document.body.classList.remove(obj.controller.options.classes.out);
    document.body.classList.value = bodyClass.classList.value;
    document.body.title = title.innerHTML;
    scroll(0, 0);

    obj.controller.options.elements.wrapper.innerHTML = "";
    obj.controller.options.elements.wrapper.innerHTML = obj.content.querySelector(obj.controller.options.classes.wrapper).innerHTML;

    var inline = [],
        loaded = 0;

    for (var i = 0; i < scripts.length; i++) {
        var tmp = document.createElement("script");

        if (scripts[i].src != "") {
            tmp.src = scripts[i].src;
            tmp.type = "text/javascript";
            obj.controller.options.elements.wrapper.appendChild(tmp);

            tmp.addEventListener("load", function () {
                loaded++;
                appendScripts();
            });
        } else {
            tmp.innerHTML = scripts[i].innerHTML;
            tmp.type = "text/javascript";
            inline.push(tmp);
        }
    }

    function appendScripts() {
        if (loaded >= scripts.length - inline.length) {
            for (var i = 0; i < inline.length; i++) {
                obj.controller.options.elements.wrapper.appendChild(inline[i]);
            }
        }
    }

    if (typeof obj.controller.options.events.afterLoad === "function") {
        obj.controller.eventListeners();
        obj.controller.options.events.afterLoad.call(obj);
        document.dispatchEvent(new Event("contentLoaded"));
    }
};

PageController.prototype.click = function (e, that) {
    if (typeof e !== "undefined") {
        e.preventDefault();
    }

    var that = this,
        url = that.link.getAttribute("href");

    document.body.classList.add(that.controller.options.classes.out);

    if (typeof that.controller.options.events.click === "function") {
        that.controller.options.events.click.call(that);
    }

    document.dispatchEvent(that.controller.options.click);

    (0, _ajax2.default)().get(url).always(function (response, xhr) {
        var content = document.createElement("html");
        content.innerHTML = response;
        if (xhr.status === 200) {
            that.controller.options.transitionEnd = that.controller.transitionEnd.bind({ controller: that.controller, content: content }, false);
            // that.controller.options.elements.wrapper.addEventListener(transitionend, that.controller.options.transitionEnd, false);
            that.controller.update({ controller: that.controller, content: content });
            history.pushState({}, "", url);
        } else {
            window.location.href = xhr.responseURL;
        }
    });
};

exports.default = PageController;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__(147);
var scrollTrack = __webpack_require__(153);

/**
 * Constructor Scroll trigger module that allows for custom animations
 *
 * @class ScrollViewport
 *
 * @classdesc a module to quickly develop scroll trigger animations
 *
 * @param {Object} options - Object instantiation options
 * @param {Number} [options.triggerClass='.scroll-trigger'] The class to add scroll trigger events to
 * @param {Number} [options.activeClass='in-viewport'] The class to add to elements once triggered
 * @param {Number} [options.animations={}] An object of animation functions
 */
function ScrollViewport(options) {
    // References
    this.options = merge({}, ScrollViewport.DEFAULTS, options);
    this.scrollTriggerElems = [];
    this.scrollTriggerElemsLen = 0;
    this.watchers = [];
    // All bindings
    this.destroy = this.destroy.bind(this);
    // Setup
    this._setup();
}

ScrollViewport.DEFAULTS = {
    triggerClass: ".scroll-trigger",
    activeClass: "in-viewport",
    animations: {}
};

module.exports = ScrollViewport;

/**
 * Setup method
 * @private
 * @return {null}
 */
ScrollViewport.prototype._setup = function () {
    var i;
    var scrollOffset;
    var defaultOffset = window.innerHeight / 4 * -1;
    this.scrollTriggerElems = [].slice.call(document.querySelectorAll(this.options.triggerClass));
    this.scrollTriggerElemsLen = this.scrollTriggerElems.length;
    i = this.scrollTriggerElemsLen;
    while (i--) {
        scrollOffset = parseInt(this.scrollTriggerElems[i].getAttribute("data-scroll-offset") || 0, 10);
        if (!scrollOffset) {
            scrollOffset = defaultOffset;
        }
        this.watchers[i] = scrollTrack.create(this.scrollTriggerElems[i], scrollOffset);
        this.watchers[i].customAnimation = this.scrollTriggerElems[i].getAttribute("data-custom-animation");
        this.watchers[i].customAnimationHasRun = false;
        this.watchers[i].enterViewport(this._onEnterViewport.bind(this, this.watchers[i]));
    }
};

/**
 * Triggered when an element enters the viewport
 * @private
 * @return {null}
 */
ScrollViewport.prototype._onEnterViewport = function (watcher) {
    if (watcher.customAnimation && !watcher.customAnimationHasRun) {
        watcher.customAnimationHasRun = true;
        this.options.animations[watcher.customAnimation](watcher.watchItem);
    }
    var that = this;
    watcher.watchItem.classList.add(that.options.activeClass);
    watcher.destroy();
    watcher = null;
};

/**
 * The Destroy method, to kill this stuff
 * @public
 * @return {null}
 */
ScrollViewport.prototype.destroy = function () {
    var i = this.watchers.length;
    while (i--) {
        if (this.watchers[i] && typeof this.watchers[i].destroy === "function") {
            this.watchers[i].destroy();
            this.watchers[i] = null;
        }
    }
};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// import anim from "animated-scrollto";

/**
 * scrolls window to exact block
 * @param  {String} selector query selector where you want screen to scroll
 */
// export default function (selector, offset) {
//     let element = document.querySelector(selector);
//     let scrollTop = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
//     anim(document.body, scrollTop + parseInt(offset), 700);
//     anim(document.documentElement, scrollTop + parseInt(offset), 700);
// }

function scrollto(el, offset) {
    var element = document.querySelector(el);
    var scrollTop = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    anim(0, scrollTop + parseInt(offset), 1);
}

var anim = function anim(scrollTop, to, duration) {
    var start = window.scrollY;
    var end = to;
    var change = end - start;
    var currentIteration = 0;
    var totalIterations = duration * 60;

    function animate() {
        var val = Math.easeInOutQuad(currentIteration, start, change, totalIterations);
        // console.log(val)
        currentIteration++;
        scrollTo(0, val);
        if (currentIteration < totalIterations) {
            requestAnimationFrame(animate);
        }
    }

    requestAnimationFrame(animate);
};

Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};

exports.default = scrollto;

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extendDefaults = __webpack_require__(16);

var _extendDefaults2 = _interopRequireDefault(_extendDefaults);

var _lodash = __webpack_require__(27);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function moveitItem(el) {
    var style = window.getComputedStyle(el),
        rect = el.getBoundingClientRect();

    this.el = el;
    this.style = style;
    this.speed = parseFloat(this.el.getAttribute("data-scroll-speed"));
    this.mode = this.el.getAttribute("data-moveit-mode");
    this.direction = this.el.getAttribute("data-moveit-direction");
    this.rect = rect;
    this.offset = {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft,
        offsetHeight: this.el.offsetHeight,
        offsetWidth: this.el.offsetWidth
    };

    if (!this.speed) {
        this.speed = 5;
    }

    if (!this.mode) {
        this.mode = "default";
    }

    if (!this.direction) {
        this.direction = "down";
    }

    this.origTranslateX = 0;
    this.origTranslateY = 0;

    if (style.getPropertyValue("transform") != "none" && style.getPropertyValue("transform") != null) {
        var transformMatrix = style.getPropertyValue("transform").split(",");
        this.origTranslateX = parseFloat(transformMatrix[4]);
        this.origTranslateY = parseFloat(transformMatrix.slice(0, -1));
    } else {
        this.el.style.transform = "translate3d(0px, 0px, 0px)";
    }

    this.centerYPos = this.offset.top + this.offset.offsetHeight / 2;
    this.centerXPos = this.offset.left + this.offset.offsetWidth / 2;

    this.window = {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth
    };
}

moveitItem.prototype.applyStyles = function (item, x, y, z) {
    (0, _lodash2.default)(function () {
        item.el.style.transform = "translate3d(" + x + "px, " + y + "px, " + z + "px)";
    }, 16)();
};

moveitItem.prototype.down = function (that) {
    var item = this;
    var scrollTop = 0;

    if (that == window) {
        that = document.body;
        scrollTop = window.scrollY;
    } else {
        scrollTop = that.scrollTop;
    }

    var start = item.offset.top - item.window.innerHeight / 2 * 3,
        end = item.offset.top + item.offset.offsetHeight + item.window.innerHeight / 2;

    if (scrollTop > start && scrollTop < end) {
        var windowCenter = scrollTop + item.window.innerHeight / 2,
            scrollDiff = windowCenter - item.centerYPos,
            pos = -1 * scrollDiff / item.speed + item.origTranslateY;

        if (scrollDiff < 0) {
            if (item.mode != "after-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, item.origTranslateX, pos, 0);
                });
            }
        } else {
            if (item.mode != "before-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, item.origTranslateX, pos, 0);
                });
            }
        }
    }
};

moveitItem.prototype.right = function (that) {
    var item = this;

    var start = item.offset.left - item.window.innerWidth / 2 * 3,
        end = item.offset.left + item.offset.offsetWidth + item.window.innerWidth / 2;

    if (that.scrollLeft > start && that.scrollLeft < end) {
        var windowCenter = that.scrollLeft + item.window.innerWidth / 2,
            scrollDiff = windowCenter - item.centerXPos,
            pos = -1 * scrollDiff / item.speed + item.origTranslateX;

        if (scrollDiff < 0) {
            if (item.mode != "after-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, pos, item.origTranslateY, 0);
                });
            }
        } else {
            if (item.mode != "before-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, pos, item.origTranslateY, 0);
                });
            }
        }
    }
};

moveitItem.prototype.update = function (that) {
    if (this.direction == "down") {
        this.down(that);
    } else if (this.direction == "right") {
        this.right(that);
    }
};

function moveit(opt) {
    var instances = [],
        elements,
        i = 0;

    this.options = {
        selector: ".moveit",
        scrollContainer: window
    };

    if ((typeof opt === "undefined" ? "undefined" : _typeof(opt)) === "object") {
        (0, _extendDefaults2.default)(this.options, opt);
    }

    elements = document.querySelectorAll(this.options.selector);
    console.log({ elements: elements });

    for (i = 0; i < elements.length; i++) {
        instances.push(new moveitItem(elements[i]));
    }

    var that = this;

    this.options.scrollContainer.addEventListener("scroll", function () {
        if (that.options.scrollContainer == window) {
            that.scrollTop = document.body.scrollTop;
            that.scrollLeft = document.body.scrollLeft;
        } else {
            that.scrollTop = that.options.scrollContainer.scrollTop;
            that.scrollLeft = that.options.scrollContainer.scrollLeft;
        }

        for (i = 0; i < instances.length; i++) {
            instances[i].update(that.options.scrollContainer);
        }
    });
}

exports.default = moveit;

/***/ })

},[160]);


// WEBPACK FOOTER //
// js/main.js